import withForm from 'hoc/withForm'
import FormikCheckbox from '@ui-components-3/compat/lib/components/FormikCheckbox'
import FormikFormattedTextField from '@ui-components-3/compat/lib/components/FormikFormattedTextField'
import FormikRadioGroup from '@ui-components-3/compat/lib/components/FormikRadioGroup'

import { cleanPhoneNumberInput, phoneInputFormat } from 'util/formatters'
import TestIds from 'util/TestIds'
import SMSSubText from 'components/common/SMSSubText'

const options = [
  { label: 'Mobile', value: 'mobile' },
  { label: 'Home', value: 'home' },
  { label: 'Office', value: 'office' },
]

type PhoneFormProps = {
  handleSubmit: () => void
  dirty: boolean
  isValid: boolean
  onCancel: () => void
}

const PhoneForm = ({ onCancel, handleSubmit, dirty, isValid }: PhoneFormProps) => {
  return (
    <form onSubmit={handleSubmit} className="w-[570px] max-w-full pt-2" data-testid={TestIds.newVisit.view.phoneForm}>
      <div className="px-s pb-s md:px-m">
        <p className="typography-body mb-s font-medium text-neutral-700">*Phone number is a required field</p>
        <FormikFormattedTextField
          fullWidth
          data-testid={TestIds.newVisit.input.phoneForm}
          formatText={phoneInputFormat}
          unformatText={cleanPhoneNumberInput}
          autoComplete="tel"
          label={'Phone Number*'}
          name={'number'}
          className="mb-s"
        />
        <FormikRadioGroup
          label={'Type'}
          name={'type'}
          options={options}
          data-testid={TestIds.newVisit.input.phoneType}
          className="mb-s"
        />
        <FormikCheckbox
          name={'acceptSms'}
          data-testid={TestIds.newVisit.input.acceptSms}
          label={'Allow SMS messaging to this number'}
        />
        <SMSSubText
          className="typography-body-l mt-2.5 text-neutral-500"
          data-testId={TestIds.newVisit.label.smsExplanation}
        />
      </div>
      <div className="px-s pb-m pt-xs md:px-m grid grid-cols-1 gap-2.5 border-t border-t-neutral-300 bg-neutral-900 sm:grid-cols-2">
        <button
          className="btn btn-neutral-outlined"
          data-testid={TestIds.phone.button.cancel}
          onClick={onCancel}
          type="button"
        >
          Cancel
        </button>
        <button
          className="btn btn-primary"
          data-testid={TestIds.phone.button.save}
          disabled={!dirty || !isValid}
          type="submit"
        >
          Save Number
        </button>
      </div>
    </form>
  )
}

export default withForm(PhoneForm)
